export class SyntheticEvent<T extends Event> {
  private _originalEvent: T;

  private _isDefaultPrevented = false;

  private _isPropagationStopped = false;

  public constructor(originalEvent: T) {
    this._originalEvent = originalEvent;
  }

  public preventDefault(): void {
    this._isDefaultPrevented = true;
  }

  public stopPropagation(): void {
    this._isPropagationStopped = true;
  }

  public get originalEvent(): T {
    return this._originalEvent;
  }

  public get isDefaultPrevented(): boolean {
    return this._isDefaultPrevented;
  }

  public get isPropagationStopped(): boolean {
    return this._isPropagationStopped;
  }
}
